export default __webpack_public_path__ + "static/media/mid_resilience_score.7d1b73a9.svg";